import React from 'react'
import { Button, Modal } from 'react-bootstrap'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { RoundedModal } from 'plugin-codaf-risk-ext-bowtie/generic'
import { DraExportData } from 'plugin-codaf-risk-ext-bowtie/services/export'
import { TextContainer } from './styles'

interface IProps {
    show: boolean
    handleClose: () => void
    type: 'risk-diagram' | 'barrier' | 'bowtie'
    setLoading: (k: boolean) => void
}

export const IncompleteExportConfimationModal: React.FC<IProps> = ({ show, handleClose, type, setLoading }) => {
    const handleIncompleteExportData = async (): Promise<void> => {
        try {
            setLoading(true)
            await DraExportData({ entityType: `${type}`, acceptEmptyArguments: 'true' })
        } catch (error) {
            globalNotification.error(error.message ?? i18n('An error occurred on exporting Risk Diagram data.'))
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <RoundedModal show={show} onHide={() => handleClose()} aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title">
                    <i className="fas fa-download" /> {i18n('Export incomplete data')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TextContainer>
                    <div style={{ fontSize: 14 }}>
                        {`${i18n('Are you sure you want to export')} ${i18n(type)}
                            ${i18n('data with incomplete arguments? ')}
                        `}
                    </div>
                    <div style={{ fontSize: 14 }}>
                        {`
                            ${i18n('We suggest you review')}
                            ${i18n(type === 'barrier' ? 'yourf' : 'yourm')} ${i18n(type + 's')} ${i18n(
                            'and complete them before you export. If you want to export it anyway, click on "Confirm incomplete export".'
                        )}`}
                    </div>
                </TextContainer>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    className="no-outline-button"
                    bsStyle="primary"
                    type="button"
                    onClick={() => handleIncompleteExportData()}
                    id="confirm-incomplete-export"
                >
                    {i18n('Confirm incomplete export')}
                </Button>
                <Button
                    className="no-outline-button"
                    type="button"
                    onClick={() => {
                        handleClose()
                    }}
                >
                    {i18n('Cancel')}
                </Button>
            </Modal.Footer>
        </RoundedModal>
    )
}
